import { render, staticRenderFns } from "./DecisionList.vue?vue&type=template&id=2116efb1&scoped=true&"
import script from "./DecisionList.vue?vue&type=script&lang=ts&"
export * from "./DecisionList.vue?vue&type=script&lang=ts&"
import style0 from "./DecisionList.vue?vue&type=style&index=0&id=2116efb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2116efb1",
  null
  
)

export default component.exports